import React from "react";
import { FormattedMessage } from "react-intl";
import { commonFields } from './formFields'
// entity/slice

const supplierPartnerOrganizationType = [
    { value: "supplier_partner", text: "Supplier Partner" }
]


export default [...commonFields,
{
    name: "organizationType",
    label: <FormattedMessage id="organization-form.type" />,
    type: "select",
    helpText: <FormattedMessage id="organization-form.help-txt-type" />,
    errorMessage: <FormattedMessage id="organization-form.err-msg-type" />,
    data: supplierPartnerOrganizationType,
    validation: {
        required: true,
    },
    disabled: true,
    selectedValue: 'supplier_partner'
},
{
    name: "recipients",
    label: <FormattedMessage id="organization-form.mail-recipients" />,
    type: "string",
    helpText: "a comma separated list of emails that we should send notifications to",
    validation: {
        required: false,
    },
},
{
    name: "shouldNotify",
    label: <FormattedMessage id="client.notify" />,
    type: "checkbox",
    helpText:
        "it allows clients to track their trips by sending trip tracking links to their email inboxes",
    validation: {
        required: false,
    },
},
];
